export const ANNUAL_DATA_VALIDATION_ALERT_DIALOG_ID = "annual-data-validation-alert";
export const ANNUAL_DATA_VALIDATION_EDIT_DIALOG_ID = "annual-data-validation-edit";
